module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-slide-down/wow-slide-down.component.scss
// module id = ./src/app/features/wow-slider/wow-slide-down/wow-slide-down.component.scss
// module chunks = main